import entitiesSelector from './entities_selector';

const schedulesSelector = entitiesSelector(state => state.schedules);

export default schedulesSelector;



/** WEBPACK FOOTER **
 ** ./src/js/selectors/schedules_selector.js
 **/